<template>
  <transition :name="transitionName" @after-leave="$emit('dodestroy')">
    <div
      id="kye-month-range3-flag"
      v-show="visible"
      class="el-picker-panel el-date-range-picker el-popper"
      :class="[
        {
          'has-sidebar': $slots.sidebar || shortcuts
        },
        popperClass
      ]">
      <div class="el-picker-panel__body-wrapper">
        <slot name="sidebar" class="el-picker-panel__sidebar"></slot>
        <!-- <div class="el-picker-panel__sidebar" v-if="shortcuts && shortcuts.length">
          <button
            type="button"
            class="el-picker-panel__shortcut kye-date3-shortcut"
            v-for="(shortcut, key) in shortcuts"
            :key="key"
            :class="{
              'is-disabled': typeof shortcut.disabled === 'function' ? shortcut.disabled() : !!shortcut.disabled
            }"
            @click="handleShortcutClick(shortcut)">
            {{ shortcut.text }}
          </button>
        </div> -->

        <ShortcutsWrap
          v-if="showShortcuts"
          :type="type"
          :shortcuts="shortcuts"
          :disabledDate="disabledDate"
          :clearable="clearable"
          :handleShortcutClick="handleShortcutClick"
        >
        </ShortcutsWrap>
        <div class="el-picker-panel__body">
          <div class="el-picker-panel__content el-date-range-picker__content is-left">
            <div class="el-date-range-picker__header">
              <button
                type="button"
                @click="leftPrevYear"
                class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
              <button
                type="button"
                v-if="unlinkPanels"
                @click="leftNextYear"
                :disabled="!enableYearArrow"
                :class="{ 'is-disabled': !enableYearArrow }"
                class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
              <!-- <div>{{ activeInputIndex === 0 ? leftLabel : rightLabel }}</div> -->
              <!-- <div class="l">{{ leftLabel }}</div> -->
              <div class="label">
                <span>{{ leftLabel }}</span>
              </div>

              <button
                type="button"
                @click="rightNextYear"
                class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
              <button
                type="button"
                v-if="unlinkPanels"
                @click="rightPrevYear"
                :disabled="!enableYearArrow"
                :class="{ 'is-disabled': !enableYearArrow }"
                class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
            </div>
            <month-table
              selection-mode="range"
              :date="leftDate"
              :default-value="defaultValue"
              :min-date="minDate"
              :max-date="maxDate"
              :activeInputIndex="activeInputIndex"
              :range-state="rangeState"
              :disabled-date="disabledDate"
              @changerange="handleChangeRange"
              @pick="handleRangePick">
            </month-table>
          </div>
          <div class="el-picker-panel__content el-date-range-picker__content is-right">
            <!-- <div class="el-date-range-picker__header">
              <button
                type="button"
                v-if="unlinkPanels"
                @click="rightPrevYear"
                :disabled="!enableYearArrow"
                :class="{ 'is-disabled': !enableYearArrow }"
                class="el-picker-panel__icon-btn el-icon-d-arrow-left"></button>
              <button
                type="button"
                @click="rightNextYear"
                class="el-picker-panel__icon-btn el-icon-d-arrow-right"></button>
              <div>{{ rightLabel }}</div>
            </div>
            <month-table
              selection-mode="range"
              :date="rightDate"
              :default-value="defaultValue"
              :min-date="minDate"
              :max-date="maxDate"
              :range-state="rangeState"
              :disabled-date="disabledDate"
              @changerange="handleChangeRange"
              @pick="handleRangePick">
            </month-table> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import moment from 'moment'
// import { isObject } from 'lodash'
import {
  isDate,
  modifyWithTimeString,
  prevYear,
  nextYear,
  nextMonth,
  VALUE_FORMAT,
  FORMAT,
  correctDatesOrder
} from '../util'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import Locale from 'element-ui/lib/mixins/locale'
import MonthTable from '../basic/month-table'
import ShortcutsWrap from '../basic/shortcuts-wrap'
import '../style/month-range.scss'

const calcDefaultValue = defaultValue => {
  if (Array.isArray(defaultValue)) {
    return [new Date(defaultValue[0]), new Date(defaultValue[1])]
  } else if (defaultValue) {
    return [new Date(defaultValue), nextMonth(new Date(defaultValue))]
  } else {
    return [new Date(), nextMonth(new Date())]
  }
}
export default {
  mixins: [Locale],

  directives: { Clickoutside },

  computed: {
    btnDisabled() {
      return !(this.minDate && this.maxDate && !this.selecting && this.isValidValue([this.minDate, this.maxDate]))
    },

    leftLabel() {
      return this.leftDate.getFullYear() + '年'
    },

    rightLabel() {
      return this.rightDate.getFullYear() + ' ' + this.t('el.datepicker.year')
    },

    leftYear() {
      return this.leftDate.getFullYear()
    },

    rightYear() {
      return this.rightDate.getFullYear() === this.leftDate.getFullYear()
        ? this.leftDate.getFullYear() + 1
        : this.rightDate.getFullYear()
    },

    enableYearArrow() {
      return this.unlinkPanels && this.rightYear > this.leftYear + 1
    }
  },

  data() {
    return {
      popperClass: '',
      value: [],
      defaultValue: null,
      defaultTime: null,
      minDate: '',
      maxDate: '',
      leftDate: new Date(),
      rightDate: nextYear(new Date()),
      rangeState: {
        hoverDate: null,
        endDate: null,
        selecting: false,
        row: null,
        column: null,
        isPick: false
      },
      shortcuts: '',
      visible: '',
      disabledDate: '',
      format: '',
      arrowControl: false,
      unlinkPanels: false,
      activeInputIndex: 0,
      type: 'monthrange',
      showShortcuts: true,
      clearable: true,
      beforeShortcutsClick: null,
      shortcutsCallback: null,
      transitionName: 'el-zoom-in-top'
    }
  },

  watch: {
    value(newVal) {
      if (!newVal) {
        this.minDate = null
        this.maxDate = null
      } else if (Array.isArray(newVal)) {
        this.minDate = isDate(newVal[0]) ? new Date(newVal[0]) : null
        this.maxDate = isDate(newVal[1]) ? new Date(newVal[1]) : null
        if (this.minDate) {
          this.leftDate = this.minDate
          if (this.unlinkPanels && this.maxDate) {
            const minDateYear = this.minDate.getFullYear()
            const maxDateYear = this.maxDate.getFullYear()
            this.rightDate = minDateYear === maxDateYear ? nextYear(this.maxDate) : this.maxDate
          } else {
            this.rightDate = nextYear(this.leftDate)
          }
        } else {
          this.leftDate = calcDefaultValue(this.defaultValue)[0]
          this.rightDate = nextYear(this.leftDate)
        }
      }
    },

    defaultValue(val) {
      if (!Array.isArray(this.value)) {
        const [left, right] = calcDefaultValue(val)
        this.leftDate = left
        this.rightDate =
          val && val[1] && left.getFullYear() !== right.getFullYear() && this.unlinkPanels
            ? right
            : nextYear(this.leftDate)
      }
    },

    visible() {
      this.rangeState.hoverDate = false
      this.rangeState.selecting = false
      this.rangeState.isPick = false
    },
  },

  methods: {
    // 清除的逻辑
    handleClearOperation(picker) {
      // 如果清除所有的值，则直接返回空
      this.$emit('pick', [], false)
      // 新增点击快捷面板点击回调
      // const beforeShortcutsClick = this.beforeShortcutsClick
      // if (typeof beforeShortcutsClick === 'function') {
      //   beforeShortcutsClick({ picker, type: 'clear', start: '', end: '' })
      // }
    },
    // 2021-08-25 增加回调，控制左侧面板显示，赋值
    callbackClickPicker(picker, userArr) {
      let start = FORMAT(moment(userArr[0]).startOf('day'), VALUE_FORMAT)
      let end = FORMAT(moment(userArr[1]).endOf('day'), VALUE_FORMAT)
      let currentDate = [start, end]
      if (this.isWeekRange) {
        currentDate = correctDatesOrder(currentDate)
      }
      this.$emit('pick', currentDate, false)
    },
    handleClear() {
      this.minDate = null
      this.maxDate = null
      this.leftDate = calcDefaultValue(this.defaultValue)[0]
      this.rightDate = nextYear(this.leftDate)
      this.$emit('pick', null)
    },

    handleChangeRange(val) {
      this.minDate = val.minDate
      this.maxDate = val.maxDate
      this.rangeState = val.rangeState
    },

    handleRangePick(val, close = true) {
      const defaultTime = this.defaultTime || []
      const minDate = modifyWithTimeString(val.minDate, defaultTime[0])
      const maxDate = modifyWithTimeString(val.maxDate, defaultTime[1])
      if (this.maxDate === maxDate && this.minDate === minDate) {
        return
      }

      this.onPick && this.onPick(val)
      this.maxDate = maxDate
      this.minDate = minDate

      this.handleDateMouseEnter({
        newDate: this.activeInputIndex === 0 ? val.minDate : val.maxDate,
        isDateRangePick: !(minDate && maxDate), // 区分是否是悬浮，是否是完整值
        val
      })

      // workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
      setTimeout(() => {
        this.maxDate = maxDate
        this.minDate = minDate
      }, 10)

      // 已有值情况
      if (this.rangeState.isPick) {
        this.handleConfirm(true)
        return
      }

      if (!close) return

      this.handleConfirm()
    },

    handleShortcutClick(shortcut) {
      // const disabled = typeof shortcut.disabled === 'function' ? shortcut.disabled() : shortcut.disabled
      // if (disabled) {
      //   return
      // }
      if (shortcut.onClick) {
        shortcut.onClick(this)
      } else if (typeof shortcut.value === 'function') {
        this.$emit('pick', shortcut.value(), false)
      }
    },

    // leftPrev*, rightNext* need to take care of `unlinkPanels`
    leftPrevYear() {
      this.leftDate = prevYear(this.leftDate)
      if (!this.unlinkPanels) {
        this.rightDate = prevYear(this.rightDate)
      }
    },

    rightNextYear() {
      if (!this.unlinkPanels) {
        this.leftDate = nextYear(this.leftDate)
      }
      this.rightDate = nextYear(this.rightDate)
    },

    // leftNext*, rightPrev* are called when `unlinkPanels` is true
    leftNextYear() {
      this.leftDate = nextYear(this.leftDate)
    },

    rightPrevYear() {
      this.rightDate = prevYear(this.rightDate)
    },

    handleConfirm(visible = false) {
      if (this.isValidValue([this.minDate, this.maxDate])) {
        this.$emit('pick', [this.minDate, this.maxDate], visible)
      }
    },

    isValidValue(value, msg = '选择的时间不可用') {
      const isRange = Array.isArray(value) && value
      const isStart = isRange && value[0] && isDate(value[0])
      const isEnd = isRange && value[1] && isDate(value[1])
      const valid =
        isStart &&
        isEnd &&
        value[0].getTime() <= value[1].getTime()
      let disabledDate = true
      if (typeof this.disabledDate === 'function') {
        disabledDate = !(isStart && this.disabledDate(value[0])) && !(isEnd && this.disabledDate(value[1]))
        if (!disabledDate) {
          this.$message.warning(msg)
        }
      }
      return valid && disabledDate
    },

    resetView() {
      // NOTE: this is a hack to reset {min, max}Date on picker open.
      // TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
      //       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
      this.minDate = this.value && isDate(this.value[0]) ? new Date(this.value[0].replace(/-/g, '/')) : null
      this.maxDate = this.value && isDate(this.value[1]) ? new Date(this.value[1].replace(/-/g, '/')) : null
    }
  },

  components: { MonthTable, ShortcutsWrap }
}
</script>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker3/src/panel/month-range.vue